import { render, staticRenderFns } from "./PillarsGoals.vue?vue&type=template&id=7391d1d9"
import script from "./PillarsGoals.vue?vue&type=script&lang=js"
export * from "./PillarsGoals.vue?vue&type=script&lang=js"
import style0 from "./PillarsGoals.vue?vue&type=style&index=0&id=7391d1d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports